import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button, I } from '@leanin/ui';
import { FlowShell, type FlowStep } from '@/components/onboarding/FlowShell';
import {
  ChecklistColumn,
} from '@/components/onboarding/ChecklistColumn';
import { clearStoredPersona } from '@/components/onboarding/persona';
import { clearPendingInviteToken } from '@/components/onboarding/pending-invite';
import { useCompleteOnboarding } from '@/lib/mutations/identity';
import { STEP_CONTENT_BY_KEY } from '@/components/onboarding/checklist-registry';
import { PERSONA_STEP_KEYS } from '@/components/onboarding/persona-steps';

const STEPS: ReadonlyArray<FlowStep> = [
  { label: 'Welcome' },
  { label: 'Find a Circle to join' },
  { label: 'Connect with your community' },
  { label: 'Build leadership skills' },
  { label: "You're in" },
];

export const Route = createFileRoute('/onboarding/cm/complete')({
  component: CMOnboardingCompletePage,
});

function CMOnboardingCompletePage() {
  const navigate = useNavigate();
  const completeOnboarding = useCompleteOnboarding();
  const finish = async (to: string = '/feed') => {
    try {
      await completeOnboarding.mutateAsync({ persona: 'cm' });
    } catch {
      // Don't block "Take me in" on a transient flag-write failure; if it
      // persists the member will simply see onboarding again next sign-in.
    }
    clearStoredPersona();
    clearPendingInviteToken();
    navigate({ to: to as '/' });
  };
  return (
    <FlowShell
      role="Circle Member"
      stepIndex={4}
      steps={STEPS}
      title="Let's get started."
      primary={
        <Button variant="primary" icon={I.arrow} onClick={() => void finish()}>
          Take me in
        </Button>
      }
      secondary={
        <Button
          variant="ghost"
          onClick={() => navigate({ to: '/onboarding/cm/welcome' })}
        >
          Return to welcome message
        </Button>
      }
    >
      <ChecklistColumn
        eyebrow="Next steps"
        title="Your Circle Member Checklist"
        items={PERSONA_STEP_KEYS['circle-member'].map((key) => {
          const { title, sub, cta, href } = STEP_CONTENT_BY_KEY[key];
          return { title, sub, cta, href };
        })}
        onNavigate={(href) => void finish(href)}
      />
    </FlowShell>
  );
}
